import { render, staticRenderFns } from "./Generalsettings.vue?vue&type=template&id=3ec35e2e&scoped=true&"
import script from "./Generalsettings.vue?vue&type=script&lang=js&"
export * from "./Generalsettings.vue?vue&type=script&lang=js&"
import style0 from "./Generalsettings.vue?vue&type=style&index=0&id=3ec35e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec35e2e",
  null
  
)

export default component.exports